import React, { useMemo } from 'react';

import { CheckboxTick } from '@components/Forms/CheckboxTick';
import { MobxZodField, MobxZodTypes, getDecodeResultOr } from '@monoid-dev/mobx-zod-form';
import { getForm } from '@monoid-dev/mobx-zod-form-react';
import { makeMuiStyles, useCommonStyles } from '@styles';
import clsx from 'clsx';
import { observer } from 'mobx-react';

const useStyles = makeMuiStyles((theme, common) => ({
  checkboxInputContainer: {
    ...common.textGray500,
    ...common.middleText,
    ...common.itemsCenter,
    position: 'relative',
    display: 'inline-flex',
    verticalAlign: 'middle',
  },
  checkbox: {
    pointerEvents: 'none',
    height: 13,
    width: 13,
  },
  checkboxHidden: {
    ...common.baseButton,
    ...common.absoluteFill,
    opacity: 0,
  },
}));

export type CheckboxInputProps<T extends MobxZodTypes> = {
  field: MobxZodField<T>;
};

export const CheckboxBooleanInput = observer(
  <T extends MobxZodTypes>({ field }: CheckboxInputProps<T>) => {
    const form = useMemo(() => getForm(field), [field]);

    const classes = {
      ...useCommonStyles(),
      ...useStyles(),
    };

    return (
      <span className={classes.checkboxInputContainer}>
        <span className={clsx(classes.checkbox)}>
          <CheckboxTick
            checked={getDecodeResultOr(field.decodeResult, false)}
            error={field.errorMessages.length > 0 && field.touched}
            style={{ height: 'inherit', width: 'inherit' }}
          />
        </span>
        <input
          className={clsx(classes.checkboxHidden)}
          {...form.bindField(field, { type: 'checkbox' })}
        />
      </span>
    );
  },
);
